import script from "./departmentInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./departmentInfo.vue?vue&type=script&setup=true&lang=js"

import "./departmentInfo.vue?vue&type=style&index=0&id=060f7222&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-060f7222"]])

export default __exports__